import styled from '@marvelapp/styled';
import Box from './Box';
const Grid = styled(Box) `
  display: grid;
`;
export default Grid;
